<sh-form-multi-select-complex-base
    [formControl]="searchControl"
    [search]="true"
    [multiple]="false"
    [isLoading]="lookupLoading$ | async"
    [loadingMsg]="'ui.search-loading' | translate"
    [noResultsFoundMsg]="'ui.no-results' | translate"
    [searchPlaceholderMsg]="'ui.search' | translate"
    [listCappedMsg]="'ui.capped-results' | translate"
    [options]="options$ | async"
    [indeterminateMsg]="indeterminateMsg"
    [disabledMsg]="disabledMsg"
    (searchTerm)="onSearchTermChange($event)"
></sh-form-multi-select-complex-base>
